import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useClientEnableBrightSyncMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseClientEntity } from 'api/helpers/client/parseClientEntity';

export const useClientEnableBrightSync = () => {
  const [handle, { data, loading, error: apolloError }] =
    useClientEnableBrightSyncMutation();

  const error = useError(apolloError);

  return {
    client: data?.client ? parseClientEntity(data.client) : undefined,
    loading,
    error,
    enableBrightSync: useCallback(
      async (id: string, versionNumber: number) => {
        const res = await handle({
          variables: { id, versionNumber },
        });
        return res.data?.client
          ? parseClientEntity(res.data?.client)
          : undefined;
      },
      [handle]
    ),
  };
};
